import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55ae484c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indicators-statistic" }
const _hoisted_2 = { class: "indicators-statistic__content" }

import { PropType } from 'vue'
import IndicatorsStatistic from '@/widgets/WIndicatorsStatistic/components/IndicatorsStatistic.vue'
import IndicatorsStatisticInfo from '@/widgets/WIndicatorsStatistic/components/IndicatorsStatisticInfo.vue'
import {
  StatisticAppointmentType,
  StatisticDoctorType,
  StatisticReportType,
} from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  reports: Array as PropType<
    StatisticReportType[] | StatisticAppointmentType[]
  >,
  doctors: Array as PropType<StatisticDoctorType[]>,
  reportType: String,
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IndicatorsStatistic, {
        reports: __props.reports,
        class: "indicators-statistic__card"
      }, null, 8, ["reports"]),
      _createVNode(IndicatorsStatisticInfo, {
        doctors: __props.doctors,
        reportType: __props.reportType
      }, null, 8, ["doctors", "reportType"])
    ])
  ]))
}
}

})